export default __webpack_public_path__ + "static/media/landing-page-3.2da89cdd.jpg";